import React from 'react'

import Container from '@components/Layout/Container'

import { CustomizableComponent } from '@contracts/components/customizableComponent'
import { SectionOptions } from '@contracts/components/customizableSection'

import * as styles from './Section.module.scss'

interface Props extends CustomizableComponent, SectionOptions {}

const Section: React.FunctionComponent<Props> = React.forwardRef((props, ref: React.ForwardedRef<HTMLDivElement>) => {
	const sectionStyles = [styles.section]

	if (props.className) {
		sectionStyles.push(props.className)
	}

	if (props.smallPadding) {
		sectionStyles.push(styles.smallPadding)
	}

	if (props.hasNoPadding) {
		sectionStyles.push(styles.hasNoPadding)
	}

	if (props.hasNoTopPadding) {
		sectionStyles.push(styles.hasNoTopPadding)
	}

	if (props.hasNoBottomPadding) {
		sectionStyles.push(styles.hasNoBottomPadding)
	}

	if (props.overflow) {
		sectionStyles.push(styles.overflow)
	}

	if (props.beforeAngledSection) {
		sectionStyles.push(styles.beforeAngledSection)
	}

	if (props.afterAngledSection) {
		sectionStyles.push(styles.afterAngledSection)
	}

	// Conditionaly Wrap section content with a container
	const wrapWithContainer = (children: React.ReactNode) => {
		const containerStyles = []

		if (props.containerClassName) {
			containerStyles.push(props.containerClassName)
		}

		return (
			<section className={sectionStyles.join(' ')} style={props.style} ref={ref}>
				<Container className={containerStyles.join(' ')} type={props.type}>
					{children}
				</Container>
			</section>
		)
	}

	return props.hasContainer ? (
		wrapWithContainer(props.children)
	) : (
		<section className={sectionStyles.join(' ')} style={props.style} ref={ref}>
			{props.children}
		</section>
	)
})

Section.defaultProps = {
	hasContainer: true,
	type: 'normal',
}

export default Section
